'use strict';

exports.__esModule = true;
exports["default"] = {
  SOCIAL: 'social',
  REVERSE_TIME: 'reverse_time',
  TIME: 'time'
};